import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess, convertFileToBlob } from 'utils/functions/general';
import { getPreSignedUrl, uploadFiles } from 'modules/common/api';

import { getCompanyProfile, updateProfileData } from './api';
import {
  fetchProfileDetailsSuccess,
  fetchProfileDetailsFail,
  fetchUpdateProfileInfoSuccess,
  fetchUpdateProfileInfoFail,
} from './actions';
import profilesActionTypes from './action-types';

function* fetchProfileDetailsSaga({ payload }) {
  try {
    const selectedCompanyProfileKey = payload.profileKey;
    if (!selectedCompanyProfileKey) throw new Error('No company selected');

    const response = yield call(getCompanyProfile, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchProfileDetailsSuccess(response.data.data));
  } catch (error) {
    yield put(fetchProfileDetailsFail(error));
  }
}

function* fetchUpdateProfileInfoSaga({ payload }) {
  const { callbackActionSuccess, callbackActionFail } = payload;

  try {
    const { data } = payload;
    const { name, description, longDescription, email, url, imageData } = data;

    const companyProfileKey = sessionStorage.getItem('companyProfileKeyAuthCookie');
    if (!companyProfileKey) throw new Error('No company selected');

    if (imageData) {
      const { compressedFileData, fileName } = imageData;

      const preSignedUrlBody = {
        headers: {
          ServiceKey: 'doctornetwork',
          'x-vzt-Component': 'doctornetwork portal',
        },
        data: {
          FilePath: `Profile/${companyProfileKey}`,
          FileName: fileName,
          RenameFile: false,
          IsPublicRead: true,
        },
      };
      const preSignedUrlResponse = yield call(getPreSignedUrl, preSignedUrlBody);

      if (checkIfAPIResponseIsSuccess(preSignedUrlResponse.status) === false)
        throw new Error('Get pre-signed URL failed');

      const preSignedUrl = preSignedUrlResponse.data.data.presignedURL;
      const fileDataBlob = yield convertFileToBlob(compressedFileData);

      const uploadImageBody = {
        url: preSignedUrl,
        headers: {
          'x-amz-acl': 'public-read',
        },
        data: fileDataBlob,
      };
      const uploadImageResponse = yield call(uploadFiles, uploadImageBody);

      if (checkIfAPIResponseIsSuccess(uploadImageResponse.status) === false)
        throw new Error('Upload file failed');
    }

    if (name) {
      sessionStorage.setItem('companyNameAuthCookie', name);
    }

    const updateProfileApiData = {};
    if (name) updateProfileApiData.name = name;
    if (description) updateProfileApiData.description = description;
    if (longDescription) updateProfileApiData.longDescription = longDescription;
    if (email) updateProfileApiData.email = email;
    if (url) updateProfileApiData.websiteUrl = url;

    const updateProfileBody = { data: updateProfileApiData, profileKey: companyProfileKey };

    const updateProfileResponse = yield call(updateProfileData, updateProfileBody);

    if (checkIfAPIResponseIsSuccess(updateProfileResponse.status) === false)
      throw new Error(updateProfileResponse.status);

    callbackActionSuccess();
    yield put(fetchUpdateProfileInfoSuccess(updateProfileResponse.data));
  } catch (error) {
    callbackActionFail();
    yield put(fetchUpdateProfileInfoFail(error));
  }
}

function* profilesSaga() {
  yield takeLatest(profilesActionTypes.FETCH_PROFILE_DETAILS, fetchProfileDetailsSaga);
  yield takeLatest(profilesActionTypes.FETCH_UPDATE_PROFILE_INFO, fetchUpdateProfileInfoSaga);
}

export default profilesSaga;
